import React from 'react';
import { Layout } from 'antd';
import { useParams } from "react-router-dom";
import AffectedUrlClusters from '../failedChecks/AffectedUrlClusters';
import FailedCheckDetails from '../failedChecks/FailedCheck/FailedCheckDetails';
import useUrlState from '../../hooks/useUrlState';
import DomainSetupCheck from '../websiteIndexEntry/DomainSetupCheck';
import useScrollToTop from '../../hooks/useScrollToTop';
import WebsiteIndexEntryTabs from '../websiteIndexEntry/WebsiteIndexEntryTabs';

const { Content } = Layout;


export default function FailedCheckPage() {
    useScrollToTop();

    const { seoTestKey } = useParams();
    const [urlState] = useUrlState();
    const { w_guid: websiteGuid, cluster_guid: clusterGuid } = urlState;

    if (!websiteGuid || !seoTestKey) {
        return null;
    }

    return (
        <Content className="general-layout-content">
            <WebsiteIndexEntryTabs>
                <DomainSetupCheck
                    key={websiteGuid}
                    websiteGuid={websiteGuid}
                >
                    <FailedCheckDetails seoTestKey={seoTestKey} />
                    <AffectedUrlClusters
                        websiteGuid={websiteGuid!}
                        clusterGuid={clusterGuid}
                        seoTestKey={seoTestKey}
                    />
                </DomainSetupCheck>
            </WebsiteIndexEntryTabs>
        </Content>
    );
}
